import { theme } from '@/styles/theme';

export const styles = {
  container: {
    paddingTop: '32px',
  },
  phoneContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  country: {
    paddingRight: '16px',
    width: '50%',
  },
  phoneField: {
    '& input[type="number"]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    /* Para Firefox */
    '& input[type="number"]': {
      MozAppearance: 'textfield',
    },
  },
  dropDownOption: {
    fontSize: '16px',
    padding: 2,
    cursor: 'pointer',
  },
  menuItems: {
    padding: 2,
  },
  day: {
    '&.MuiPickersDay-root.Mui-selected': {
      backgroundColor: theme.palette.focus.main,
    },
    '&.MuiPickersDay-today': {
      backgroundColor: 'transparent',
      border: 'none',
    },
  },
};
